//      
import {               } from 'css-box-model';
import { add } from '../position';
                                                                  

export default (droppable                    , point          )           => {
  const frame              = droppable.frame;
  if (!frame) {
    return point;
  }

  return add(point, frame.scroll.diff.displacement);
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/with-scroll-change/with-droppable-displacement.js